module.exports = __webpack_public_path__ + "09cd7ed3630398988892a32748d05e18.png";